var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65355 5.482C2.02985 6.21812 1.56543 7.07547 1.28955 8C2.15088 10.892 4.82955 13 8.00022 13C8.66222 13 9.30222 12.908 9.90888 12.7367M4.15222 4.152C5.29396 3.39854 6.63227 2.99788 8.00022 3C11.1709 3 13.8489 5.108 14.7102 7.99867C14.2381 9.5782 13.2249 10.941 11.8482 11.848M4.15222 4.152L2.00022 2M4.15222 4.152L6.58555 6.58533M11.8482 11.848L14.0002 14M11.8482 11.848L9.41488 9.41467C9.60062 9.22893 9.74795 9.00844 9.84847 8.76577C9.94898 8.52309 10.0007 8.263 10.0007 8.00033C10.0007 7.73767 9.94898 7.47757 9.84847 7.2349C9.74795 6.99223 9.60062 6.77173 9.41488 6.586C9.22915 6.40027 9.00865 6.25294 8.76598 6.15242C8.52331 6.0519 8.26322 6.00016 8.00055 6.00016C7.73788 6.00016 7.47779 6.0519 7.23512 6.15242C6.99245 6.25294 6.77195 6.40027 6.58622 6.586M9.41422 9.414L6.58688 6.58667",
    stroke: "#407BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.267101b26ec9e321e4063cb7a2778f3c.svg";
export { ForwardRef as ReactComponent };